import { Bars3Icon } from "@heroicons/react/24/outline";
import { JSX, useState } from "react";
import logo from "@/assets/img/logo.png";
import logoWhite from "@/assets/img/logo-white.png";
import UseScrolled from "../hooks/useScrolled";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { Dialog } from "@headlessui/react";

const styles = {
    root: (scrolled: boolean) =>
        `fixed inset-x-0 top-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`,
    nav: "flex items-center justify-between p-6 lg:px-8",
    logoLink: "-m-1.5 p-1.5",
    logoImg: "object-contain transition-transform duration-200 hover:scale-110 text-shadow-md",
    mobileMenuBtn: "-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700 hover:text-[#66c6ba]",
    desktopNav: "hidden lg:flex lg:gap-x-12",
    desktopNavLink: (scrolled: boolean) =>
        `text-sm font-semibold transition-colors duration-300 ${scrolled ? 'text-[#4d8291] hover:text-[#66c6ba]' : 'text-white hover:text-gray-300'} ${!scrolled ? 'text-shadow-md' : ''}`,
    desktopLogin: "hidden lg:flex lg:flex-1 lg:justify-end",
    dialog: "lg:hidden",
    dialogBg: "fixed inset-0 z-50",
    dialogPanel: "fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10",
    dialogHeader: "flex items-center justify-between",
    dialogLogo: "-m-1.5 p-1.5",
    dialogLogoImg: "object-contain transition-transform duration-200 hover:scale-110 lg:hidden",
    dialogCloseBtn: "-m-2.5 rounded-md p-2.5 text-gray-700 hover:text-[#66c6ba]",
    dialogMenu: "mt-6 flow-root",
    dialogMenuInner: "-my-6 divide-y divide-gray-500/10",
    dialogNav: "space-y-2 py-6",
    dialogNavLink: "-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-[#4d8291] hover:bg-[#66c6ba] hover:text-white",
    dialogLogin: "py-6"
};

const navigation = [
    { name: 'Funcionalidades', href: '#more-info' },
    { name: 'Nuestra Misión', href: '#mission' },
    { name: 'Contacto', href: '#contact' },
]

const Navbar = (): JSX.Element => {
    const scrolled = UseScrolled();
    const [mobileMenuOpen, setMobileMenuOpen] = useState<boolean>(false)

    return (
        <div className={styles.root(scrolled)}>
            <nav className={styles.nav} aria-label="Global">
                <div className="flex lg:flex-1">
                    <a href="/" className={styles.logoLink}>
                        <img
                            width={160}
                            height={40}
                            src={scrolled ? logo : logoWhite}
                            alt="AppCotas"
                            className={styles.logoImg}
                        />
                    </a>
                </div>
                <div className="flex lg:hidden">
                    <button
                        type="button"
                        className={styles.mobileMenuBtn}
                        onClick={() => setMobileMenuOpen(true)}
                    >
                        <span className="sr-only">Abrir menú principal</span>
                        <Bars3Icon color={scrolled ? '#4d8291' : '#ffffff'} className="h-6 w-6" aria-hidden="true" />
                    </button>
                </div>
                <div className={styles.desktopNav}>
                    {navigation.map((item) => (
                        <a
                            key={item.name}
                            href={item.href}
                            className={styles.desktopNavLink(scrolled)}
                            onClick={e => {
                                e.preventDefault();
                                const id: string = item.href.replace('#', '');
                                const el: HTMLElement | null = document.getElementById(id);
                                if (el) {
                                    el.scrollIntoView({ behavior: "instant" });
                                }
                            }}
                        >
                            {item.name}
                        </a>
                    ))}
                </div>
                <div className={styles.desktopLogin}>
                    {/* <a
                        href={'/login'}
                        className={`text-sm font-semibold transition-colors duration-300 ${scrolled ? 'text-[#4d8291] hover:text-[#66c6ba]' : 'text-white hover:text-gray-300'} ${!scrolled ? 'text-shadow-md' : ''}`}
                    >
                        Iniciar sesión <span aria-hidden="true">&rarr;</span>
                    </a> */}
                </div>
            </nav>
            <Dialog as="div" className={styles.dialog} open={mobileMenuOpen} onClose={setMobileMenuOpen}>
                <div className={styles.dialogBg} />
                <Dialog.Panel className={styles.dialogPanel}>
                    <div className={styles.dialogHeader}>
                        <a href="/" className={styles.dialogLogo}>
                            <img
                                width={160}
                                height={40}
                                src={logo}
                                alt="AppCotas"
                                className={styles.dialogLogoImg}
                            />
                        </a>
                        <button
                            type="button"
                            className={styles.dialogCloseBtn}
                            onClick={() => setMobileMenuOpen(false)}
                        >
                            <span className="sr-only">Cerrar menú</span>
                            <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                        </button>
                    </div>
                    <div className={styles.dialogMenu}>
                        <div className={styles.dialogMenuInner}>
                            <div className={styles.dialogNav}>
                                {navigation.map((item) => (
                                    <a
                                        key={item.name}
                                        href={item.href}
                                        onClick={() => setMobileMenuOpen(false)}
                                        className={styles.dialogNavLink}
                                    >
                                        {item.name}
                                    </a>
                                ))}
                            </div>
                            <div className={styles.dialogLogin}>
                                {/* <Link href={'/login'} className={`text-sm font-semibold transition-colors duration-300 ${scrolled ? 'text-[#4d8291] hover:text-[#66c6ba]' : 'text-white hover:text-gray-300'}`}>
                                            Iniciar sesión
                                        </Link> */}
                            </div>
                        </div>
                    </div>
                </Dialog.Panel>
            </Dialog>
        </div>
    );
}

export default Navbar;
